export let api = {
    protocol: 'https://',
    url: 'szamlazo.bizxpert.hu',
    //url: 'dev.ks.hu',
    createUserRoute: '/api/createuser',
    loginurl: '/login/',
    demouri: '/demo/'
};

/*
* szamlazo.bizxpert.hu
*
* let api = {
    protocol: 'https://',
    url: 'szamlazo.bizxpert.hu',
    createUserRoute: '/api/createuser',
    loginurl: '/login/'
};
 */